import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { columns } from "@/components/ui/table/columns/privacy-policy";
import { DataTable } from "@/components/ui/table/data-table";
import Loader from "@/components/utils/loader";
import { CreatePolicyForm, UpdatePolicyForm } from "@/pages";
import { useStore } from "@/store";
import { Plus } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Toaster } from "sonner";

const PirvacyPolicyDataTable = () => {
  const { t } = useTranslation();
  const getPrivacyPolicies = useStore((state) => state.getPrivacyPolicies);
  const privacyPolicies = useStore((state) => state.privacyPolicies);
  const updateModal = useStore((state) => state.updateModal);
  const setUpdateModal = useStore((state) => state.setUpdateModal);
  const selectedLanguage = useStore((state) => state.selectedLanguage);
  const [createModal, setCreateModal] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const loadPolicies = async () => {
      try {
        await getPrivacyPolicies();
      } catch (error) {
        console.error("Load policies error", error);
      } finally {
        if (active) setLoading(false);
      }
    };
    void loadPolicies();
    return () => { active = false; };
  }, [getPrivacyPolicies]);

  const formattedPolicies = useMemo(() =>
    (privacyPolicies || []).map((policy) => ({
      id: policy.id,
      identifier: policy.type || "",
      title:
        policy.preTexts.find((text) => text.language === selectedLanguage)
          ?.text || "not text in this language",
      policyText:
        policy.postTexts.find((text) => text.language === selectedLanguage)
          ?.text || "not text in this language",
    })), [privacyPolicies, selectedLanguage]);

  const handleCloseModal = () => {
    setUpdateModal(false);
  };

  const handleCloseCreateModal = () => {
    setCreateModal(false);
  };

  return (
    <section className="w-full">
      <Toaster />
      <section className="w-full flex mb-3">
        <Dialog
          open={createModal}
          onOpenChange={(isOpen) => setCreateModal(isOpen)}
        >
          <DialogTrigger asChild={true}>
            <Button className="mt-4 bg-primary hover:bg-primary-600">
              {t("buttonTexts.addNew")} <Plus className="ml-2" />
            </Button>
          </DialogTrigger>
          <DialogContent className="w-[92vw] sm:max-w-[65vw] max-h-[92vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>
                {t("MainLayout.privacyPolicy.createPrivacyPolicy")}
              </DialogTitle>
            </DialogHeader>
            <CreatePolicyForm onClose={handleCloseCreateModal} />
          </DialogContent>
        </Dialog>
      </section>
      <section className="w-full flex">
        <Dialog
          open={updateModal}
          onOpenChange={(isOpen) => setUpdateModal(isOpen)}
        >
          <DialogContent className="w-[92vw] sm:max-w-[65vw] max-h-[92vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>
                {t("MainLayout.privacyPolicy.updatePricavyPolicy")}
              </DialogTitle>
            </DialogHeader>
            <UpdatePolicyForm onClose={handleCloseModal} />
          </DialogContent>
        </Dialog>
      </section>
      {loading ? (
        <div className="flex justify-center h-screen">
          <Loader style={"loader"} />
        </div>
      ) : (
        <DataTable
          data={formattedPolicies}
          columns={columns}
          mainFilterColumn="title"
          textPlaceholder={t("filterTextPlaceholders.privacyPolicy")}
        />
      )}
    </section>
  );
};

export default PirvacyPolicyDataTable;
